import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { FieldValue, LinksFieldArray } from '../types';

export type FieldArrayState = {
  fields: FieldValue[];
  onSubmitAllFields: (values: LinksFieldArray) => void;
  onSubmitChangedFields: (values: LinksFieldArray) => void;
  totalFieldsCount: number;
};

export const initialFieldArrayState = {
  fields: [] as FieldArrayState['fields'],
  onSubmitAllFields: noop,
  onSubmitChangedFields: noop,
  totalFieldsCount: 0,
};

export const FieldArrayContext = createContext(initialFieldArrayState);

export const useFieldArrayContext = () => useContext(FieldArrayContext);
